import React from 'react'
import { actionPlanTableHeader, ErrorStep4Type, FocusedInputType, StepFourType } from '../helpers'
import { Control, FieldArrayWithId, UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import ActionPlanTableRow from './ActionPlanTableRow';

interface IActionTableProps {
  fields:FieldArrayWithId<{
    fields: StepFourType[];
  }, "fields", "id">[]
  notAllowed: boolean
  errors: ErrorStep4Type
  setFocusedInputData: React.Dispatch<React.SetStateAction<FocusedInputType>>
  removeField: (index: number) => void
  register: UseFormRegister<{ fields: StepFourType[] }>
  setValue: UseFormSetValue<{ fields: StepFourType[] }>
  control: Control<{ fields: StepFourType[] }, any>
  getValues: UseFormGetValues<{ fields: StepFourType[] }>
  isStaticData?: boolean
  trigger: UseFormTrigger<any>
}
export default function ActionTable({ fields,
  notAllowed,
  errors,
  setFocusedInputData,
  register,
  setValue,
  control,
  removeField,
  getValues,
  isStaticData,
  trigger
}: IActionTableProps) {
  return (
    <table
      data-testid="test-action-table"
      className="w-full rounded-t-lg outline outline-2 outline-[#E0E0E0] table-fixed"
    >
        <thead className="sticky top-0 z-[1] ">
            <tr className="divide-x-2 divide-[#E0E0E0] ">
          {actionPlanTableHeader.map((item, idx) => {
                  const isFirstItem = idx ===0
                  const isLastItem = idx ===actionPlanTableHeader?.length -1
                    return (
                      <th className={`px-4 py-[6px] text-left  bg-[#EEEEF4] border-b-2 border-[#E0E0E0]
                        ${isLastItem ? "rounded-tr-lg" : ""}
                        ${isFirstItem ? "rounded-tl-lg" : ""}
                        `
                      } key={idx}>
                            <p className="font-bold text-blueTheme">
                                {item.title}
                            </p>
                            <p className="text-xs text-darkGray/80 font-normal italic">
                                {item.subtitle}
                            </p>
                        </th>
                    )
                })}
            </tr>
        </thead>
        <tbody className="divide-y-2 divide-[#E0E0E0] bg-white h-full">
            {fields.map((forum, idx) => {
                return (
                  <ActionPlanTableRow
                  trigger={trigger}
                        isStaticData={isStaticData}
                        disabledForRole={notAllowed}
                        errors={errors}
                        setFocusedInputData={setFocusedInputData}
                        handleDelete={removeField}
                        key={forum.id}
                        index={idx}
                        register={register}
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                    />
                )
            })}
        </tbody>
    </table>

  )
}
